require('./product-detail.less');

require('../news/news.less');
require('../product-card/product-card.less');

let slickDefaults = require('../slick-default/slick-default');

let size = require('../../modules/size');

jQuery(function() {
    function setProductCard($card) {
        if ($card == undefined) $card = $('.product-card');

        var $cardPreviews = $card.find('.js-slick-previews:visible');
        var $cardPreviewsCompact = $card.find('.js-slick-previews-compact:visible');

        if ($cardPreviews.length > 0) {
            $cardPreviews.slick(
                $.extend({}, slickDefaults.params, {
                    slidesToShow: 4,
                    vertical: false,
                    verticalSwiping: false,
                    responsive: [
                        {
                            breakpoint: size.tabletBig,
                            settings: { slidesToShow: 4 }
                        },
                        {
                            breakpoint: size.mobileBig,
                            settings: { slidesToShow: 2 }
                        },
                        {
                            breakpoint: size.mobile,
                            settings: { slidesToShow: 2 }
                        },
                        {
                            breakpoint: size.tablet,
                            settings: {
                                slidesToShow: 3
                            }
                        }
                    ]
                })
            );
        }

        /* if ($cardPreviewsCompact.length > 0) {
            $cardPreviewsCompact.slick(
                $.extend({}, slickDefaults.params, {
                    slidesToShow: 4,
                    vertical: true,
                    verticalSwiping: true,
                    responsive: [
                        {
                            breakpoint: size.desktop,
                            settings: {
                                slidesToShow: 4,
                                vertical: false,
                                verticalSwiping: false
                            }
                        },
                        {
                            breakpoint: size.tabletBig,
                            settings: {
                                slidesToShow: 3,
                                vertical: false,
                                verticalSwiping: false
                            }
                        },
                        {
                            breakpoint: size.tablet,
                            settings: {
                                slidesToShow: 4,
                                vertical: true,
                                verticalSwiping: true
                            }
                        }
                    ]
                })
            );
        }*/
    }

    setProductCard();

    $(document).on('click', '.js-change-main-img', function(e) {
        e.preventDefault();
        var $this = $(this);
        var $mainImg = $this.closest('.product-card').find('#product-card-main-img');
        var $mainVideo = $this.closest('.product-card').find('#product-card-main-video');
        var $video = $('#product-card-main-video').get(0);
        var bigImgSrc = $this.data('big-img');
      console.log($this);
        var classCurrent = 'product-card__previews-item--current';

        $this
            .closest('.product-card__previews')
            .find('.' + classCurrent)
            .removeClass(classCurrent);

        $this.addClass(classCurrent);

      if ($this.hasClass('product-detail__images-slider-item--video')) {
        $mainImg.fadeOut(100,function(){
          $mainVideo.fadeIn();
            $video.play();
        });
      }




        var img = new Image();
        img.onload = function() {
            $mainImg.fadeOut(1, function() {

              $mainImg.fadeIn(300);
              $mainVideo.fadeOut('1',function(){
                $video.pause();
              });

                $mainImg.removeClass('item--pdf');
                if ($this.hasClass('product-detail__images-slider-item--pdf')) {
                    $mainImg.attr('data-href', $this.attr('href'));
                    $mainImg.addClass('item--pdf');
                }
                console.log($this);
                $mainImg.attr('src', bigImgSrc);


            });



        };
        img.src = bigImgSrc;
    });

    $(document).on('click', '.item--pdf', function(e) {
        var $this = $(this);
        window.open($this.attr('data-href'));
    });
});



// WEBPACK FOOTER //
// ./blocks/product-detail/product-detail.js